module.exports = __webpack_public_path__ + "static/media/undraw_profile_3.e993abbd.svg";